import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_INSTANCE_ACTIONS from '../Actions/ActionTypes';
import { courseInstanceDetailsInitState } from './CourseInstanceInitState';
import { ICourse } from '../../../__core/Interfaces/ICourse';

export const courseInstanceDetailsReducer = (
  state: IApiJsonResponse<ICourse> = courseInstanceDetailsInitState,
  action: IAction<IApiJsonResponse<ICourse>>
): IApiJsonResponse<ICourse> => {
  switch (action.type) {
    case COURSE_INSTANCE_ACTIONS.FETCH_COURSE_DETAILS:
      return { ...action.payload };

    default:
      return state;
  }
};
